import { defineMessage } from 'services/localization';

export const messages = {
    enableAutoApprovalOrReviewStep: defineMessage('enable_autoapproval_or_review_step'),
    enableAutoApprovalStep: defineMessage('enable_autoapproval_step'),
    descriptionAutoApprovalLabel: defineMessage('autoapproval_step_2'),
    descriptionAutoApproval: defineMessage('templatename_matching_t__automatically_approved'),
    descriptionReviewLabel: defineMessage('review_step_1'),
    descriptionReview: defineMessage('templatename_matching_t_e_editable_by_reviewers'),
    learnMore: defineMessage('learn_more'),
    hide: defineMessage('hide'),
    tryNow: defineMessage('try_now'),
};
